// extracted by mini-css-extract-plugin
export default {"modalOverlay":"nD-z","modalContent":"oD-z","header":"pD-z","close":"qD-z"};